
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule5DataInfoType, schedule5outsideBcInfoType } from '@/types/Application/CaseManagement/PDF';

import { namespace } from "vuex-class";
import "@/store/modules/application";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
import GreyBoxForm from "@/components/utils/PopulateForms/components/GreyBoxForm.vue";
const applicationState = namespace("Application");

@Component({
    components: {
        UnderlineForm,
        CheckBox,
        GreyBoxForm
    }
})
export default class Schedule5 extends Vue {

    @Prop({ required: true })
    result!: any;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    dataReady = false;

    otherParties: schedule5DataInfoType[] = [];
    outsideBCinfo = {} as schedule5outsideBcInfoType;

    mounted() {
        this.dataReady = false;
        this.outsideBCinfo = this.getOtherPartyContactInfo();
        this.dataReady = true;
    }

    public getOtherPartyContactInfo() {
        const emptyParty = {
            name: '',
            lawyer: '',
            dob: '',
            address: { city: "", country: "", postcode: "", state: "", street: "" },
            contact: { email: "", phone: '' }
        } as schedule5DataInfoType;

        this.otherParties = []

        let otherpartySurvey = []
        if (this.result?.contactInformationOtherPartySurvey?.otherPartyInfo && this.$store.state.Application.steps[this.stPgNo.CM._StepNo].pages[this.stPgNo.CM.ContactInformationOtherParty].active) {
            otherpartySurvey = this.result.contactInformationOtherPartySurvey.otherPartyInfo
        }
        else if (this.result?.otherPartyCommonSurvey) {
            otherpartySurvey = this.result.otherPartyCommonSurvey
        }
        else {
            this.otherParties.push(emptyParty, emptyParty)
        }

        for (const chgSurvey of otherpartySurvey) {
            let otherPartyContactInfo = {} as schedule5DataInfoType;
            otherPartyContactInfo.name = Vue.filter('getFullName')(chgSurvey.name);
            otherPartyContactInfo.address = chgSurvey.address ? chgSurvey.address : emptyParty.address;
            otherPartyContactInfo.contact = chgSurvey.contactInfo ? chgSurvey.contactInfo : emptyParty.contact;
            otherPartyContactInfo.lawyer = chgSurvey.lawyer
            otherPartyContactInfo.dob = Vue.filter('beautify-date')(chgSurvey.dob)

            this.otherParties.push(otherPartyContactInfo)
        }


        let outsideBcInfo = {} as schedule5outsideBcInfoType;
        if (this.result?.recognizingAnOrderFromOutsideBcSurvey) {
            const chgSurvey = this.result.recognizingAnOrderFromOutsideBcSurvey;
            outsideBcInfo.orderDate = Vue.filter('beautify-date-blank')(chgSurvey.dateOfOrder)
            outsideBcInfo.orderPlace = chgSurvey.orderPlace
        }
        return outsideBcInfo;
    }

}
